{
  "Can i translate this ?": "¿Puedo traducir esto?",
  "Accounts": "Cuentas conectadas",
  "Site settings": "Ajustes del sitio",
  "Language": "Idioma",
  "Enable Marmaid": "Enable Marmaid",
  "Enable Blur": "Enable Blur",
  "Enable Animations": "Animaciones habilitadas",
  "Personal information": "Información personal",
  "NO": "NO",
  "YES": "Sí.",
  "General": "General",
  "Profile": "Perfil",
  "Notifications": "Notificaciones",
  "Identity": "Identidad",
  "Tokens": "Tokens",
  "Instances": "Instances",
  "Domains": "Dominios",
  "Sessions": "Períodos de sesiones",
  "My Sessions": "Mis sesiones",
  "No projects": "No hay proyectos",
  "Create project": "Crear proyecto",
  "Projects": "Proyectos",
  "Project name": "Nombre del proyecto",
  "Project description": "Descripción del proyecto",
  "Select team": "Seleccionar equipo",
  "Set unique description for project": "Establecer descripción única para el proyecto",
  "Please fill out this field.": "Por favor, llena este campo.",
  "Create": "Crear",
  "OwnedBy": "OwnedBy",
  "Open": "Abierto",
  "Settings": "Ajustes",
  "Apps": "Aplicaciones",
  "Logout": "Cerrar sesión",
  "Admin": "Admin",
  "Iot": "Iot",
  "Name": "Nombre",
  "Email": "Email",
  "You have being mentioned inside": "Has sido mencionado dentro",
  "from project": "del proyecto",
  "by": "por",
  "You have being invited as member inside project": "Usted ha sido invitado como miembro dentro del proyecto",
  "to build awesome things": "para construir cosas impresionantes"
}